export const USER_LANGUAGE_EN = 'en'
export const USER_LANGUAGE_ES = 'es'
export const USER_LANGUAGE_DE = 'de'
export const USER_LANGUAGE_FR = 'fr'
